import { createContext } from 'react';

export type AppView = 'upload' | 'main' | 'quiz-take' | 'flashcards' | 'quizzes' | 'quiz-detail' | 'quiz-results-history' | 'quiz-result-detail';

export interface AppContextValue {
  currentView: AppView;
  isLoading: boolean;
  error: string | null;
  setView: (view: AppView) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const AppContext = createContext<AppContextValue | undefined>(undefined);